import { useWorkspace } from '../context/workspace-context';
import { TIER_LIMITS, TierLimits } from '../constants/tier-limits';

export function useTier(): { limits: TierLimits | null } {
  const { currentWorkspace } = useWorkspace();
  const limits = currentWorkspace ? TIER_LIMITS[currentWorkspace.tier] : null;
  return { limits };
}
